import { render, staticRenderFns } from "./CardPackInstantEffect.vue?vue&type=template&id=5797b6d6"
import script from "./CardPackInstantEffect.vue?vue&type=script&lang=js"
export * from "./CardPackInstantEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports